import { createAction, props } from '@ngrx/store';
import { AlarmManagementModel } from '@models/alarm-management.model';

export const resetToInitialState = createAction('[ALARM MANAGEMENTS] Reset to Initial state');

// Load Active Alarms
export const startGetActiveAlarms = createAction('[ALARM MANAGEMENTS] Start get active alarms');
export const getActiveAlarms = createAction('[ALARM MANAGEMENTS] Get active alarms');
export const getActiveAlarmsSuccess = createAction('[ALARM MANAGEMENTS] Get active alarms Success',
  props<{ activeAlarms: AlarmManagementModel.AlarmData[] }>()
);
export const getActiveAlarmsFail = createAction('[ALARM MANAGEMENTS] Get active alarms Fail');

// Load Canceled Alarms
export const startGetCanceledAlarms = createAction('[ALARM MANAGEMENTS] Start get canceled alarms');
export const getCanceledAlarms = createAction('[ALARM MANAGEMENTS] Get canceled alarms');
export const getCanceledAlarmsSuccess = createAction('[ALARM MANAGEMENTS] Get canceled alarms Success',
  props<{ canceledAlarms: AlarmManagementModel.AlarmData[] }>()
);
export const getCanceledAlarmsFail = createAction('[ALARM MANAGEMENTS] Get canceled alarms Fail');

// Load All Alarms with Filter
export const getAlarmHistory = createAction('[ALARM MANAGEMENTS] Get alarm history',
  props<{ filter?: AlarmManagementModel.AlarmFilter }>()
);
export const getAlarmHistorySuccess = createAction('[ALARM MANAGEMENTS] Get alarm history Success',
  props<{ alarms: AlarmManagementModel.AlarmData[] }>()
);
export const getAlarmHistoryFail = createAction('[ALARM MANAGEMENTS] Get alarm history Fail');

// Create Alarm
export const createAlarm = createAction('[ALARM MANAGEMENTS] Create alarm',
  props<{ createAlarm: AlarmManagementModel.CreateAlarm }>()
);
export const createAlarmSuccess = createAction('[ALARM MANAGEMENTS] Create alarm Success',
  props<{ alarmId: string }>()
);
export const createAlarmFail = createAction('[ALARM MANAGEMENTS] Create alarm Fail');

// Cancel Alarm
export const cancelAlarm = createAction('[ALARM MANAGEMENTS] Cancel alarm',
  props<{ alarmId: string}>()
);
export const cancelAlarmSuccess = createAction('[ALARM MANAGEMENTS] Cancel alarm Success');
export const cancelAlarmFail = createAction('[ALARM MANAGEMENTS] Cancel alarm Fail');

// Check Active Alarm for Location
export const checkActiveAlarm = createAction('[ALARM MANAGEMENTS] Check active alarm',
  props<{ locationId: string }>()
);
export const checkActiveAlarmSuccess = createAction('[ALARM MANAGEMENTS] Check active alarm Success',
  props<{ checkResult: AlarmManagementModel.AlarmCheckResponse }>()
);
export const checkActiveAlarmFail = createAction('[ALARM MANAGEMENTS] Check active alarm Fail');

// UI State
export const setAlarmsLoading = createAction('[ALARM MANAGEMENTS] Set Alarms Loading',
  props<{ isLoading: boolean }>()
);

export const setSelectedAlarm = createAction('[ALARM MANAGEMENTS] Set Selected Alarm',
  props<{ alarm: AlarmManagementModel.AlarmData | null }>()
);

export const setAlarmFilter = createAction('[ALARM MANAGEMENTS] Set Alarm Filter',
  props<{ filter: AlarmManagementModel.AlarmFilter }>()
);

// New: Get Alarms with Alerts
export const startGetAlarmsWithAlerts = createAction('[ALARM MANAGEMENTS] Start get alarms with alerts',
  props<{ filter?: AlarmManagementModel.AlarmsWithAlertsFilter }>()
);
export const getAlarmsWithAlerts = createAction('[ALARM MANAGEMENTS] Get alarms with alerts',
  props<{ filter?: AlarmManagementModel.AlarmsWithAlertsFilter }>()
);
export const getAlarmsWithAlertsSuccess = createAction('[ALARM MANAGEMENTS] Get alarms with alerts Success',
  props<{ response: AlarmManagementModel.PaginatedResponse<AlarmManagementModel.AlarmWithAlerts> }>()
);
export const getAlarmsWithAlertsFail = createAction('[ALARM MANAGEMENTS] Get alarms with alerts Fail');

// New: Get Alert Instances for Alarm
export const getAlarmAlertInstances = createAction('[ALARM MANAGEMENTS] Get alarm alert instances',
  props<{ alarmId: string; pagination?: AlarmManagementModel.PaginationParams }>()
);
export const getAlarmAlertInstancesSuccess = createAction('[ALARM MANAGEMENTS] Get alarm alert instances Success',
  props<{ alarmId: string; response: AlarmManagementModel.PaginatedResponse<AlarmManagementModel.AlertInstanceSummary> }>()
);
export const getAlarmAlertInstancesFail = createAction('[ALARM MANAGEMENTS] Get alarm alert instances Fail',
  props<{ alarmId: string }>()
);

// New: Get Noonlight Activity
export const getAlertNoonlightActivity = createAction('[ALARM MANAGEMENTS] Get alert Noonlight activity',
  props<{ alertInstanceId: number }>()
);
export const getAlertNoonlightActivitySuccess = createAction('[ALARM MANAGEMENTS] Get alert Noonlight activity Success',
  props<{ alertInstanceId: number; activities: AlarmManagementModel.NoonlightActivityLog[] }>()
);
export const getAlertNoonlightActivityFail = createAction('[ALARM MANAGEMENTS] Get alert Noonlight activity Fail',
  props<{ alertInstanceId: number }>()
);

// New: Get Rejected Alerts
export const startGetRejectedAlerts = createAction('[ALARM MANAGEMENTS] Start get rejected alerts',
  props<{ filter?: AlarmManagementModel.RejectedAlertsFilter & AlarmManagementModel.PaginationParams }>()
);
export const getRejectedAlerts = createAction('[ALARM MANAGEMENTS] Get rejected alerts',
  props<{ filter?: AlarmManagementModel.RejectedAlertsFilter & AlarmManagementModel.PaginationParams }>()
);
export const getRejectedAlertsSuccess = createAction('[ALARM MANAGEMENTS] Get rejected alerts Success',
  props<{ response: AlarmManagementModel.PaginatedResponse<AlarmManagementModel.RejectedAlert> }>()
);
export const getRejectedAlertsFail = createAction('[ALARM MANAGEMENTS] Get rejected alerts Fail');

// New: UI State for tabs and expanded rows
export const setSelectedTab = createAction('[ALARM MANAGEMENTS] Set Selected Tab',
  props<{ tab: AlarmManagementModel.SelectedTab }>()
);

export const toggleExpandedAlarm = createAction('[ALARM MANAGEMENTS] Toggle Expanded Alarm',
  props<{ alarmId: string }>()
);

export const setExpandedAlarms = createAction('[ALARM MANAGEMENTS] Set Expanded Alarms',
  props<{ alarmIds: string[] }>()
);

export const clearExpandedAlarms = createAction('[ALARM MANAGEMENTS] Clear Expanded Alarms');
